import { IonSegment, IonSegmentButton, IonLabel, isPlatform} from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSegmentSelected } from "../../../store/userShow";
import { selectSegmentSelected } from "../../../store/userShow/selectors/selectSegmentSelected";
import { MessagesList } from "./MessagesList";
import { PersonalDataSection } from "./PersonalDataSection";
import { RolesList } from "./RolesList";
import { TodoListSection } from "./TodoListSection";
import { UserDocumentsFolder } from "./UserDocumentsFolder";

export const SegmentsSection = ({userId}:any) => {
  const dispatch = useDispatch();
  const segmentSelected = useSelector(selectSegmentSelected);
  return (
    <section>
      <section className="ion-padding-horizontal">
        <IonSegment
          onIonChange={(e) => {
            dispatch(setSegmentSelected(e.detail.value || ""));
          }}
          value={segmentSelected}
          color="primary"
          style={{ maxWidth: "500px" }}
        >
          <IonSegmentButton value="history">
            <IonLabel>Bitácora</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="todoList">
            <IonLabel>Acuerdos</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="info">
            <IonLabel>{isPlatform('mobile') ? "Info. Gral." : "Informacion General"}</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="documentos">
            <IonLabel>Documentos</IonLabel>
          </IonSegmentButton>
        </IonSegment>
      </section>
      <section style={{ maxWidth: "1000px" }} className="ion-margin-top">
        {/* {segmentSelected === "info" && <InfoSection />} */}
        {segmentSelected === "history" && <MessagesList />}
        {segmentSelected === "todoList" && <TodoListSection />}
        {segmentSelected === "info" && (
          <>
            <PersonalDataSection />
            <RolesList />
          </>
        )}
        {segmentSelected === 'documentos' && <UserDocumentsFolder userId={userId}/>}
      </section>
    </section>
  );
};
